import React from 'react';

interface Props {
  content: string;
  ariaLabel?: string;
}

export const HelpIcon: React.FC<Props> = ({ content, ariaLabel }) => (
  <span
    className="inline-flex items-center justify-center w-4 h-4 ml-1 text-xs rounded-full bg-gray-200 text-gray-600 cursor-help align-middle"
    title={content}
    aria-label={ariaLabel ?? content}
    role="img"
  >
    ⓘ
  </span>
);

export default HelpIcon;
